import React, { FC } from 'react';
import { ConsentCheckListCheckboxProps } from './ConsentsListItem.types';
import { ConsentCheckListItem } from '../../../../molecules/ConsentCheckListItem';
import { ConsentCheckbox, ConsentSectionType, LegalConsent } from '../../LegalConsents.types';

export const ConsentCheckList: FC<ConsentCheckListCheckboxProps> = ({
  linkBehavior,
  consentData,
  consentSectionType,
  validateErrors,
  onModalOpen,
  onCheckboxToggle,
  onLinkClickInCheckbox,
  closeAccordionBtnLabel,
  openAccordionBtnLabel,
}) => {
  const showErrorField = validateErrors && consentSectionType === ConsentSectionType.Required;

  const getErrorMessageClassName = (checkbox: ConsentCheckbox, consentData: LegalConsent): string => {
    const checkboxErrorMessageClassOverride = checkbox.errorMessageClassNameOverride?.trim() ?? '';
    if (checkboxErrorMessageClassOverride) {
      return checkboxErrorMessageClassOverride;
    }
    const checkboxErrorMessageClassName = checkbox.errorMessageClassName?.trim() ?? '';
    if (checkboxErrorMessageClassName) {
      return `m-checkbox-error ${checkboxErrorMessageClassName}`;
    }
    const consentErrorMessageClassOverride = consentData.errorMessageClassNameOverride?.trim() ?? '';
    if (consentErrorMessageClassOverride) {
      return consentErrorMessageClassOverride;
    }
    const consentErrorMessageClassName = consentData.errorMessageClassName?.trim() ?? '';
    if (consentErrorMessageClassName) {
      return `m-checkbox-error ${consentErrorMessageClassName}`;
    }

    return 'm-checkbox-error';
  };

  const getTermsLinkClass = (checkbox: ConsentCheckbox) => {
    const { termsLinkLabelClassNameOverride, termsLinkLabelClassName, termsLink, termsLinkLabel } = checkbox;

    if (termsLinkLabelClassNameOverride) {
      return termsLinkLabelClassNameOverride;
    }

    const isNewTabTermsLink = !!(termsLink && termsLinkLabel && linkBehavior === 'newTab');

    if (isNewTabTermsLink) {
      return `${termsLinkLabelClassName} m-link-tertiary-button-external`;
    }

    return termsLinkLabelClassName;
  };

  return (
    <>
      {consentData.checkboxes.map(checkbox =>
        checkbox.shadowCheckbox ? (
          <></>
        ) : (
          <ConsentCheckListItem
            key={`checkbox-${checkbox.name}`}
            linkBehavior={linkBehavior}
            label={checkbox.label.markdown}
            title={checkbox.title}
            titleClassName={checkbox.titleClassName}
            titleClassNameOverride={checkbox.titleClassNameOverride}
            errorLabel={checkbox.errorMessage}
            termsBtnLabel={checkbox.termsLinkLabel}
            termsLink={checkbox.termsLink}
            selectedConsentId={consentData.id}
            sectionType={consentData.sectionType}
            className={checkbox.checkboxClassNameOverride ?? checkbox.checkboxClassName}
            checkboxContainerClassName={
              checkbox.checkboxContainerClassNameOverride ?? checkbox.checkboxContainerClassName
            }
            checkboxLabelContainerClassName={`js-checkbox-label ${
              checkbox.checkboxLabelContainerClassNameOverride ?? checkbox.checkboxLabelContainerClassName ?? ''
            }`}
            checkboxInnerLabelClassName={checkbox.labelClassNameOverride ?? checkbox.labelClassName}
            name={checkbox.name}
            isDisabled={checkbox.isDisabled}
            isChecked={checkbox.checked}
            showCheckbox={checkbox.showCheckbox}
            onModalOpen={onModalOpen}
            onChange={onCheckboxToggle}
            onLinkClickInCheckbox={onLinkClickInCheckbox}
            linkClass={getTermsLinkClass(checkbox)}
            linkTarget={checkbox.termsLinkTarget || ''}
            errorMessageClassName={getErrorMessageClassName(checkbox, consentData)}
            validateErrors={showErrorField}
            closeAccordionBtnLabel={closeAccordionBtnLabel}
            openAccordionBtnLabel={openAccordionBtnLabel}
          />
        )
      )}
    </>
  );
};
